import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { StripeService } from 'src/app/services/stripe.service';

@Component({
  selector: 'app-customer-card-info',
  templateUrl: './customer-card-info.component.html',
  styleUrls: ['./customer-card-info.component.scss']
})
export class CustomerCardInfoComponent implements OnInit {

  customer: any;
  paymentMethods: any;
  stripeCustomer: any;
  stripeCustomerInfo: any;
  cardBrandLogos = {
    'visa': 'assets/img/payment-logo/visa-logo.png',
    'mastercard': 'assets/img/payment-logo/mastercard-logo.png',
    'american_express': 'assets/img/payment-logo/american-express-logo.png',
    'discover': 'assets/img/payment-logo/discover-logo.png',
    'diners_club': 'assets/img/payment-logo/dinners-club-logo.png',
    'jcb': 'assets/img/payment-logo/jcb-logo.jpg',
    'default': 'assets/img/payment-logo/default-logo.jpg'
  };
  groups: string[];
  disableBtn: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { customer },
    private stripeService: StripeService,
    private spinnerService: SpinnerService,
    private commanUsesService: CommanUsesService,
    private authStatusService: AuthStatusService,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.customer = this.data.customer;
  }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      await this.fetchDetails();
      this.spinnerService.hide();
    } catch (error) {
      this.commanUsesService.showSnackBar("SOMETHING_WENT_WRONG");
      this.spinnerService.hide();
    }
  }

  async fetchDetails() {
    const data = await this.stripeService.getStripeCustomerInformation(this.customer.id);
    this.stripeCustomerInfo = data;
    this.stripeCustomer = this.stripeCustomerInfo.stripeCustomer;
    this.paymentMethods = this.stripeCustomerInfo.paymentMethods;

    this.paymentMethods = this.stripeCustomerInfo.paymentMethods.sort((a: any, b: any) => {
      const aIsDefault = this.getDefaultCard(a?.id);
      const bIsDefault = this.getDefaultCard(b?.id);

      if (aIsDefault && !bIsDefault) return -1;
      if (!aIsDefault && bIsDefault) return 1;
      return 0;
    });
  }

  getCardLogo(brand: string): string {
    return this.cardBrandLogos[brand] || this.cardBrandLogos['default'];
  }

  getDefaultCard(cardId: string): boolean {
    return String(this.stripeCustomer.invoice_settings.default_payment_method) === String(cardId);
  }

  async setDefaultCard(cardId: string) {
    try {

      if(!confirm(`Sei sicuro? Questa carta verrà utilizzata per i pagamenti.`)) return;
      this.disableBtn = true;

      const promiseResult = await this.stripeService.setDefaultCard(this.customer.stripeCustId, cardId);
      this.commanUsesService.showSnackBar("La carta predefinita è stata modificata correttamente");
      await this.fetchDetails();
      
    } catch (error) {
      const errorMessage: string = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMessage);
    }
  }

}
